import { Skeleton } from '@design-system/Skeleton';
import { StandardContainer } from '@design-system/StandardContainer';

const DoctorsNoteShimmer = () => {
  return (
    <StandardContainer>
      <div className="mt-8 flex flex-col gap-3 select-none">
        <Skeleton className="w-1/3 h-8" />

        <div className="grid sm:grid-cols-3 grid-cols-2 gap-4 w-full h-full">
          {[1, 2].map((_, index) => (
            <Skeleton
              key={`grid-skeleton-${index}`}
              className={`w-full h-60 rounded-lg block`}
            />
          ))}
        </div>
      </div>
    </StandardContainer>
  );
};

export default DoctorsNoteShimmer;
